import { Modal } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { capitalize } from '../mainUtils';
import useURLParams from '../hooks/useURLParams';
import { ActorsConstants } from '../actors/constants/actionTypes';
import axiosRequest from '../api/api';

function DeleteActorModal({
  targetType = 'actor',
  onFailure,
  onSuccess,
  data,
  uuid,
  modalVisible,
  setModalVisible,
}) {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const getUrl = () => {
    switch (targetType) {
      case 'actor':
        return 'delete/actor';
      case 'public_interface':
        return 'public_interfaces/delete';
      case 'certificate':
        return 'services/certificates/delete';
      default:
        return '';
    }
  };

  const getTypes = () => {
    switch (targetType) {
      case 'actor':
        return [
          ActorsConstants.REMOVE_ACTOR_REQUEST,
          ActorsConstants.REMOVE_ACTOR_SUCCESS,
          ActorsConstants.REMOVE_ACTOR_FAILURE,
          // ActorsConstants.REMOVE_ACTOR_CANCEL
        ];
      case 'public_interface':
      case 'certificate':
        return [];
      default:
        return [];
    }
  };

  const requestDeleteActor = () => new Promise((resolve, reject) => {
    dispatch(
      axiosRequest.post(
        getUrl(),
        getTypes(),
        data || { uuid },
        {
          onSuccess: resolve,
          onFailure: reject,
          onCancel: reject,
        },
      ),
    );
  });

  const handeCancel = (e) => {
    e.stopPropagation();
    setModalVisible(false);
  };

  return (
    <Modal
      open={modalVisible}
      title={capitalize(t('auth.buttons.remove_actor', 'remove actor'))}
      maskClosable
      centered
      closable
      okText={capitalize(t('auth.buttons.remove', 'remove'))}
      okType="danger"
      okButtonProps={{
        className: 'button-danger',
      }}
      cancelText={capitalize(t('auth.buttons.cancel', 'cancel'))}
      cancelButtonProps={{
        className: 'button-secondary-outlined',
      }}
      onOk={(e) => {
        e.stopPropagation();
        requestDeleteActor()
          .then(() => {
            if (onSuccess) {
              onSuccess(uuid);
            }
            setModalVisible(false);
          })
          .catch(() => {
            if (onFailure) {
              onFailure();
            }
            setModalVisible(false);
          });
      }}
      onCancel={handeCancel}
      destroyOnClose
    >
      {capitalize(t(
        `auth.messages.delete_sure_${targetType}`,
        `are you sure you want to delete this ${targetType}?`,
      ))}
    </Modal>
  );
}

export default DeleteActorModal;

DeleteActorModal.propTypes = {
  targetType: PropTypes.string,
  onFailure: PropTypes.func,
  onSuccess: PropTypes.func,
  data: PropTypes.object,
  uuid: PropTypes.string,
  modalVisible: PropTypes.bool,
  setModalVisible: PropTypes.func,
};
